module.exports = "/static/assets/66a613e869e2913719f14338b88ef84d.png";